import {ImageBackground, Keyboard, Pressable, Text, TextInput, TouchableWithoutFeedback, View} from "react-native";

import React from "react";

import {styles} from "../common/styles";
import {WhiteViewHeader} from "../common/WhiteViewHeader";
import {KeyboardAvoidingViewWrapper} from "../common/KeyboardAvoidingViewWrapper";
import {i18n} from "../common/localization";

import bg from "../assets/sign-up-bg.png";

export const SignUp = () => {
    function onPressSignup() {
        console.log("Sign up");
    }

    return (
        <TouchableWithoutFeedback onPress={Keyboard.dismiss}>
            <View style={styles.container}>
                <ImageBackground source={bg} resizeMode="contain" style={{...styles.whiteViewBgImageContainer, width: 274, height: 155}}>

                </ImageBackground>
                <KeyboardAvoidingViewWrapper style={styles.whiteViewContainer}>
                    <View style={{justifyContent: "flex-start"}}>
                        <WhiteViewHeader/>
                        <Text style={styles.whiteViewTitleText}>{i18n.t("signUp")}</Text>
                        <View style={{...styles.whiteViewScrollView, marginTop: 38}}>
                            <View style={styles.login.inputContainer}>
                                <TextInput
                                    style={styles.signup.input}
                                    placeholder={i18n.t("yourName")}
                                    placeholderTextColor="#242424"
                                    keyboardType="default"
                                />
                            </View>
                            <View style={styles.login.inputContainer}>
                                <TextInput
                                    style={styles.signup.input}
                                    placeholder={i18n.t("yourLastName")}
                                    placeholderTextColor="#242424"
                                    keyboardType="default"
                                />
                            </View>
                            <View style={styles.login.inputContainer}>
                                <TextInput
                                    style={styles.signup.input}
                                    placeholder={i18n.t("yourEmail")}
                                    placeholderTextColor="#242424"
                                    keyboardType="default"
                                />
                            </View>
                            <View style={styles.login.inputContainer}>
                                <TextInput
                                    style={styles.signup.input}
                                    placeholder={i18n.t("createPassword")}
                                    placeholderTextColor="#242424"
                                    secureTextEntry={true}
                                    keyboardType="default"
                                />
                            </View>
                        </View>
                    </View>
                    <View style={{...styles.buttonContainer, paddingHorizontal: 24}}>
                        <Pressable onPress={onPressSignup} color={"none"} style={styles.button}>
                            <Text style={styles.buttonText}>{i18n.t("signUp")}</Text>
                        </Pressable>
                    </View>
                </KeyboardAvoidingViewWrapper>
            </View>
        </TouchableWithoutFeedback>
    )
}
